import axios from 'axios';


//export const host = '192.168.3.15:8888';
//export const host = '192.168.3.37:8002';
export const host = 'www.hruibo.cn';

const prefix = '/scfb/api/';
export const domain = 'http://' + host;

// 登录
export const login = params => {
  return axios.post('/login/', params);
};

// person
export const createUserPerson = params => {
  return axios.post('/person/', params);
};
export const updateUserPerson = (id,params) => {
  return axios.patch('/person/'+ id + '/', params);
};
export const getUserPerson = (id) => {
  return axios.get('/person/' + id +'/');
};


// organization
export const createUserOrganization = params => {
  return axios.post('/organization/', params);
};
export const updateUserOrganization = (id, params) => {
  return axios.patch('/organization/'+ id + '/', params);
};
export const getUserOrganization = (id) => {
  return axios.get('/organization/' + id +'/');
};

// slides
export const getSlideList = params => {
  return axios.get('/info/slides/', {params: params});
};

//events
export const getEventList = params => {
  return axios.get('/info/events/', {params: params});
};

// news
export const getNewsList = params => {
  return axios.get('/info/news/', {params: params});
};
export const getNewsInfo = id => {
  return axios.get('/info/news/'+ id + '/')
};

// members information
export const getMemberList = params => {
  return axios.get('/info/members/', {params: params});
};
export const getMemberInfo = id => {
  return axios.get('/info/members/'+ id + '/')
};

// society information
export const getSocietyList = params => {
  return axios.get('/info/society/', {params: params});
};
export const getSocietyInfo = id => {
  return axios.get('/info/society/'+ id + '/')
};


export const getActivityCategory = params => {
  return axios.get('/activity/category/', {params: params});
};

// activity
export const getActivityList = params => {
  return axios.get('/activities/', {params: params});
};
export const getActivityInfo = id => {
  return axios.get('/activities/'+ id + '/')
};

// dynamics
export const getDynamicList = params => {
  return axios.get('/activity/dynamics/', {params: params});
};
export const getDynamicInfo = id => {
  return axios.get('/activity/dynamics/'+ id + '/')
};

// registrations
export const getRegistrationList = params => {
  return axios.get('/activity/registrations/', {params: params});
};
export const getRegistrationInfo = id => {
  return axios.get('/activity/registrations/'+ id + '/')
};
export const createRegistration = params => {
  return axios.post('/activity/registrations/', params)
};








// WEBPACK FOOTER //
// ./src/api/api.js